var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import ScrollContainer from 'react-indiana-drag-scroll';
export var FloorImageContainer = styled(ScrollContainer).attrs(function () { return ({
    ignoreElements: '.floorplanner-marker-tool',
    nativeMobileScroll: true,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  height: 100%;\n  overflow: auto;\n"], ["\n  position: relative;\n  height: 100%;\n  overflow: auto;\n"])));
var templateObject_1;
//# sourceMappingURL=FloorImageContainer.js.map